import ckTheme from './cloudkitchens';
import entitiesSharedColors from './entitiesSharedColors';

const mono = '#3E5C34';
const monoContrast = '#FFFFFF';
const monoDark = '#1A370F';
const monoLight = '#C0CD73';

export default {
  colors: {
    ...ckTheme.colors,
    primary: mono,
    'primary-dark': monoDark,
    'primary-light': monoLight,
    'primary-contrast': monoContrast,
    secondary: mono,
    'secondary-dark': monoDark,
    'secondary-light': monoLight,
    'secondary-contrast': monoContrast,
    tertiary: mono,
    'tertiary-dark': monoDark,
    'tertiary-light': monoLight,
    'tertiary-contrast': monoContrast,
    'accent-1': monoLight,

    ...entitiesSharedColors,
  },
  fonts: {},
};
